var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Route, Switch, withRouter } from 'react-router-dom';
import * as React from 'react';
import { connect } from 'react-redux';
import { Container, Grid, Loader } from 'semantic-ui-react';
import Render from 'components/Render';
import HomePage from 'app/containers/Main/Main';
import { useAuth0 } from '@auth0/auth0-react';
import { isFirstLogin, processUserObject } from 'app/helpers/AuthServices';
import { beginLogin, beginUpdateUser, beginUserAppMetaUpdate, handleLogin, } from '../User/userActions';
import { checkIfProfileComplete, getCookie, getSignupProgramName, removeCookie, setCookie, } from '../../helpers/userHelper';
import OnboardingIndex from '../Onboarding/OnboardingIndex';
function ProtectedRouteContainer(props) {
    var _this = this;
    var handlePostLogin = props.handlePostLogin, user = props.user, history = props.history, handleUpdateUser = props.handleUpdateUser, handleUserMetaUpdate = props.handleUserMetaUpdate;
    var _a = useAuth0(), loginWithRedirect = _a.loginWithRedirect, Auth0User = _a.user, isLoading = _a.isLoading, isAuthenticated = _a.isAuthenticated, getIdTokenClaims = _a.getIdTokenClaims;
    React.useEffect(function () {
        var handleAuth = function () { return __awaiter(_this, void 0, void 0, function () {
            var searchParams, accessToken, user_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!isLoading && !isAuthenticated)) return [3 /*break*/, 2];
                        // search with `?code=` is related to Auth0 and that should not be stored in the cookies
                        if (window.location.search && window.location.search.indexOf('?code=') === -1) {
                            setCookie('neo_redirect_url', window.location.search, {
                                expires: new Date(new Date().getTime() + 5 * 60 * 1000),
                            });
                        }
                        return [4 /*yield*/, loginWithRedirect()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!(!isLoading && isAuthenticated)) return [3 /*break*/, 5];
                        if (Auth0User && getCookie('neo_redirect_url')) {
                            searchParams = getCookie('neo_redirect_url');
                            removeCookie('neo_redirect_url');
                            window.location.href = "".concat(window.location.origin, "/").concat(searchParams);
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, getIdTokenClaims()];
                    case 3:
                        accessToken = (_a.sent()).__raw;
                        return [4 /*yield*/, processUserObject(__assign(__assign({}, Auth0User), { accessToken: accessToken }))];
                    case 4:
                        user_1 = (_a.sent()).user;
                        handlePostLogin(user_1);
                        handleUpdateUser(user_1);
                        if (isFirstLogin(user_1)) {
                            window.neo4jSandbox.tracking.event('register', {
                                programName: getSignupProgramName(),
                            });
                            handleUserMetaUpdate({
                                key: 'createdAt',
                                value: Date.now(),
                                user_id: user_1.sub,
                            });
                        }
                        _a.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        if (!user.accessToken)
            handleAuth();
    }, [isLoading, isAuthenticated]);
    React.useEffect(function () {
        if (user.accessToken) {
            var hasCompleteProfile = checkIfProfileComplete(user);
            if (!hasCompleteProfile && location.pathname !== '/onboarding') {
                var searchParams = new URLSearchParams(window.location.search);
                // These are Auth0 params after successful auth which should not be carried forward to the onboarding page
                searchParams.delete('code');
                searchParams.delete('state');
                history.push({
                    pathname: '/onboarding',
                    search: searchParams.toString(),
                });
            }
        }
    }, [user]);
    return (React.createElement("div", null,
        React.createElement(Render, { if: !(isAuthenticated && user.accessToken) },
            React.createElement(Container, { className: "mt2" },
                React.createElement(Grid, null,
                    React.createElement(Grid.Column, { className: "mt5" },
                        React.createElement("div", { className: "text-center", style: { marginTop: 24 } },
                            React.createElement(Loader, { active: true, inline: "centered", inverted: true })))))),
        React.createElement(Render, { if: isAuthenticated && user.accessToken },
            React.createElement(Switch, null,
                React.createElement(Route, { exact: true, path: "/onboarding", component: OnboardingIndex }),
                React.createElement(Route, { exact: true, path: "/", component: HomePage }),
                React.createElement(Route, { path: "*", component: HomePage })))));
}
var mapStateToProps = function (state) { return ({
    user: state.user,
}); };
var mapDispatchToProps = function (dispatch) { return ({
    handleBeginLogin: function () { return dispatch(beginLogin()); },
    handlePostLogin: function (result) { return dispatch(handleLogin(result)); },
    handleUserMetaUpdate: function (params) { return dispatch(beginUserAppMetaUpdate(params)); },
    handleUpdateUser: function (user) { return dispatch(beginUpdateUser(user)); },
}); };
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ProtectedRouteContainer));
